var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.introText)?_c('v-alert',{staticClass:"mb-4",attrs:{"type":"info","dense":""}},[_vm._v(" "+_vm._s(_vm.introText)+" ")]):_vm._e(),_c('Register',{attrs:{"create-mode":'emit',"prefill-email":_vm.signatoryEmail,"min-adult-age":_vm.minAdultAge},on:{"created":_vm.handleCreated,"previusStep":_vm.handleCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }